export type VideoSurfaceType = 'surfaceView' | 'textureView';
export type VideoSourceMode = 'stream' | 'download';
export type VideoWrapperHeightMode = 'fixed' | 'full';
export type VideoWrapperBackground = 'opaque' | 'semitransparent';

export type VideoDebugVariation = {
  id: string;
  label: string;
  surfaceType: VideoSurfaceType;
  sourceMode: VideoSourceMode;
  wrapperHeightMode?: VideoWrapperHeightMode;
  wrapperRounded?: boolean;
  wrapperBackground?: VideoWrapperBackground;
  gradientBackground?: boolean;
};

export type VideoDebugSource = {
  id: string;
  label: string;
  url: string;
};

export const VIDEO_DEBUG_VARIATIONS: VideoDebugVariation[] = [
  {
    id: 'surface-stream',
    label: 'SurfaceView + Stream (base)',
    surfaceType: 'surfaceView',
    sourceMode: 'stream',
  },
  {
    id: 'surface-stream-dyn-height',
    label: 'SurfaceView + Stream · dyn height',
    surfaceType: 'surfaceView',
    sourceMode: 'stream',
    wrapperHeightMode: 'full',
  },
  {
    id: 'surface-stream-dyn-height-rounded',
    label: 'SurfaceView + Stream · dyn height + rounded',
    surfaceType: 'surfaceView',
    sourceMode: 'stream',
    wrapperHeightMode: 'full',
    wrapperRounded: true,
  },
  {
    id: 'surface-stream-semitransparent',
    label: 'SurfaceView + Stream · semitransparent bg',
    surfaceType: 'surfaceView',
    sourceMode: 'stream',
    wrapperBackground: 'semitransparent',
  },
  {
    id: 'surface-stream-gradient-bg',
    label: 'SurfaceView + Stream · gradient screen bg',
    surfaceType: 'surfaceView',
    sourceMode: 'stream',
    gradientBackground: true,
  },
  // Hidden for this test pass — keep for later re-enable.
  // {
  //   id: 'surface-download',
  //   label: 'SurfaceView + Download',
  //   surfaceType: 'surfaceView',
  //   sourceMode: 'download',
  // },
  // {
  //   id: 'texture-download',
  //   label: 'TextureView + Download',
  //   surfaceType: 'textureView',
  //   sourceMode: 'download',
  // },
  // {
  //   id: 'texture-stream',
  //   label: 'TextureView + Stream',
  //   surfaceType: 'textureView',
  //   sourceMode: 'stream',
  // },
];

export const VIDEO_DEBUG_SOURCES: VideoDebugSource[] = [
  {
    id: 'main',
    label: 'Main (1080×1920 AVC)',
    url: 'https://dj14u43q22646.cloudfront.net/videos/802348d7ff3377dc95a56a265bfc0362c0f56f5f020a5f5ca30ade6221e5dec9.mp4',
  },
];

export const DEFAULT_VIDEO_DEBUG_SOURCE_ID = 'main';

export function getVariationById(
  id: string | undefined,
): VideoDebugVariation | undefined {
  if (!id) return undefined;
  return VIDEO_DEBUG_VARIATIONS.find((v) => v.id === id);
}

export function getVideoSourceById(
  id: string | undefined,
): VideoDebugSource | undefined {
  if (!id) return undefined;
  return VIDEO_DEBUG_SOURCES.find((s) => s.id === id);
}
